import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('employee_upload_details')
export class UploadDetailesEntity {

    @PrimaryGeneratedColumn('increment', { name: 'employee_leaves_id' })
    employeeLeavesId: number;

    @Column("varchar", {
        nullable: false,
        length: 12,
        name: "employee_code"
    })
    employeeCode: string;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "employee_name"
    })
    employeeName: string;

    @Column("varchar", {
        nullable: false,
        name: "gender"
    })
    gender: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "designation"
    })
    designation: string;

    @Column("varchar", {
        length: 20,
        name: "department"
    })
    department: string;

    @Column("varchar", {
        length: 20,
        name: "priority_one"
    })
    priorityOne: string;

    @Column("varchar", {
        length: 20,
        name: "priority_two"
    })
    priorityTwo: string;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "employee_status"
    })
    employeeStatus: string;

    @Column("int", {
        name: "year_of_experience"
    })
    yearOfExperience: Number;

    @Column("varchar", {
        name: "email_id"
    })
    emailId: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "mobile_number"
    })
    mobileNumber: string;

}



